import React, { useState } from 'react'
import Calendar from './pages/Calendar'
import Login from './pages/Login'
import Subscribe from './pages/Subscribe'
import Unsubscribe from './pages/Unsubscribe'
import './App.css'

function isAuthenticated() {
  return sessionStorage.getItem('im_auth') === '1'
}

function currentPath() {
  return window.location.pathname
}

export default function App() {
  const [authed, setAuthed] = useState(isAuthenticated())

  // Public routes — no auth needed
  if (currentPath() === '/subscribe') return <Subscribe />
  if (currentPath() === '/unsubscribe') return <Unsubscribe />

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="app-logo">
          <span className="logo-triangle">▲</span>
          <span className="logo-text">INSIDE MAG</span>
          <span className="logo-sub">editorial</span>
        </div>
        <button className="logout-btn" onClick={() => {
          sessionStorage.removeItem('im_auth')
          setAuthed(false)
        }}>Sign out</button>
      </header>
      <main className="app-main">
        <Calendar />
      </main>
    </div>
  )
}
